/* AMAVAS storefront behaviour.
   Everything is progressive: the page reads and buys fine with JS disabled,
   because every control is a real link or a real <form> underneath. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (id) { return document.getElementById(id); };

  /* ------------------------------------------------------------ money --- */
  function money(cents) {
    var fmt = (window.AMAVAS && window.AMAVAS.moneyFormat) || '₹{{amount}}';
    var amount = (cents / 100);
    // Shopify's money_format placeholders, handled for the ones we actually use.
    if (fmt.indexOf('amount_no_decimals') > -1) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/,
        Math.round(amount).toLocaleString('en-IN'));
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/,
      amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  /* -------------------------------------------------------- starfield --- */
  function makeStars(c) {
    if (!c) return;
    var x = c.getContext('2d');
    // Hash-random, not a sine of the index: sine placement banded the stars
    // into visible arcs and left the edges of the canvas bare.
    function rnd(n) { var t = Math.sin(n * 127.1 + 311.7) * 43758.5453; return t - Math.floor(t); }
    var stars = [];
    for (var i = 0; i < 160; i++) {
      stars.push({ a: rnd(i + .1) * .6 + .35, r: rnd(i + .2) * 1.1 + .35,
                   px: rnd(i + .3), py: rnd(i + .4), s: .002 + rnd(i + .5) * .004 });
    }
    var t = 0;
    function draw() {
      x.clearRect(0, 0, c.width, c.height);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        var tw = reduced ? s.a : (Math.sin(t * s.s * 60 + i) * .5 + .5) * s.a;
        x.globalAlpha = .15 + tw * .55;
        x.fillStyle = '#F5F4F1';
        x.beginPath(); x.arc(s.px * c.width, s.py * c.height, s.r, 0, 7); x.fill();
      }
      x.globalAlpha = 1;
    }
    // A <canvas> is a replaced element: CSS size alone does not set the
    // drawing buffer, so the field must be re-measured on every resize or the
    // stars stop short of the edges.
    function size() { c.width = c.offsetWidth; c.height = c.offsetHeight; draw(); }
    function loop() { t++; draw(); requestAnimationFrame(loop); }
    window.addEventListener('resize', size);
    size();
    if (!reduced) loop();
  }

  /* ----------------------------------------------------- waning moon --- */
  function moonScroll() {
    var ball = $('moonball'), shadow = $('moonshadow'),
        label = $('moonlabel'), hint = $('moonhint');
    if (!ball || !shadow) return;
    function tick() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
      shadow.style.transform = 'translateX(' + (-105 + p * 105) + '%)';
      ball.style.boxShadow = '0 0 ' + (24 - p * 22) + 'px rgba(255,255,255,' + (.35 - p * .33) + ')';
      if (label) label.style.opacity = p > .93 ? 1 : 0;
      if (hint) hint.style.opacity = p > .12 ? 0 : 1;
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* ----------------------------------------------------------- sound --- */
  function sound() {
    var btn = $('soundtoggle'), audio = $('breeze');
    if (!btn || !audio) return;
    audio.volume = 0.25;
    function paint(on) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? 'Sound · On' : 'Sound · Off';
    }
    var want = true;
    try { if (sessionStorage.getItem('amavas-sound') === 'off') want = false; } catch (e) {}
    // Browsers block autoplay until the visitor interacts; try, and fall back
    // quietly to Off rather than showing an On button that isn't playing.
    if (want && !reduced) {
      audio.play().then(function () { paint(true); }).catch(function () { paint(false); });
    } else { paint(false); }

    btn.addEventListener('click', function () {
      if (audio.paused) {
        audio.play().then(function () {
          paint(true);
          try { sessionStorage.setItem('amavas-sound', 'on'); } catch (e) {}
        }).catch(function () { paint(false); });
      } else {
        audio.pause(); paint(false);
        try { sessionStorage.setItem('amavas-sound', 'off'); } catch (e) {}
      }
    });
  }

  /* ------------------------------------------------------------ menu --- */
  function menu() {
    var m = $('menu'); if (!m) return;
    function open() { m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lock'); window.dispatchEvent(new Event('resize')); }
    function close() { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lock'); }
    var btn = $('menubtn'), x = $('menuclose');
    if (btn) btn.addEventListener('click', open);
    if (x) x.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.__closeMenu = close;
  }

  /* ------------------------------------------------------ cart drawer --- */
  var Cart = {
    open: function () {
      if (window.__closeMenu) window.__closeMenu();
      var c = $('cart'); if (!c) return;
      c.classList.add('open'); c.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lock');
    },
    close: function () {
      var c = $('cart'); if (!c) return;
      c.classList.remove('open'); c.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lock');
    },
    fetch: function () {
      return fetch(window.AMAVAS.routes.cart, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(Cart.render);
    },
    add: function (id, qty, properties) {
      // Forward line-item properties; the reservation form relies on
      // properties[Reserving] to record which fragrance was reserved.
      var item = { id: id, quantity: qty || 1 };
      if (properties && Object.keys(properties).length) item.properties = properties;
      return fetch(window.AMAVAS.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
        return r.json();
      }).then(function () { return Cart.fetch(); }).then(function () { Cart.open(); });
    },
    change: function (line, qty) {
      return fetch(window.AMAVAS.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(Cart.render);
    },
    render: function (cart) {
      var items = $('citems'), total = $('ctotal'), checkout = $('ccheckout');
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      if (!items) return cart;
      if (!cart.items.length) {
        items.innerHTML = '<p class="cempty">Your bag is empty - the night is young.</p>';
        if (checkout) checkout.setAttribute('disabled', 'disabled');
      } else {
        items.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') +
                    '" alt="" loading="lazy">' : '<span></span>';
          return '<div class="citem">' + img +
            '<div class="cmeta"><a href="' + it.url + '">' + it.product_title + '</a>' +
            (it.variant_title && it.variant_title !== 'Default Title'
              ? '<small>' + it.variant_title + '</small>' : '') +
            '<div class="qty">' +
              '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) +
              '" aria-label="Reduce quantity">&minus;</button>' + it.quantity +
              '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) +
              '" aria-label="Increase quantity">+</button>' +
            '</div></div>' +
            '<span>' + money(it.line_price) + '</span></div>';
        }).join('');
        if (checkout) checkout.removeAttribute('disabled');
      }
      if (total) total.textContent = money(cart.total_price);
      return cart;
    }
  };
  window.AmavasCart = Cart;

  /* ------------------------------------------------------------- boot --- */
  document.addEventListener('DOMContentLoaded', function () {
    makeStars($('stars'));
    makeStars($('stars2'));
    moonScroll();
    sound();
    menu();

    // Reveal-on-scroll for editorial blocks.
    var els = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }

    // Cart drawer wiring.
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); Cart.open(); });
    });
    var cc = $('cartclose'); if (cc) cc.addEventListener('click', Cart.close);
    var cw = $('cart');
    if (cw) cw.addEventListener('click', function (e) { if (e.target === cw) Cart.close(); });
    var ci = $('citems');
    if (ci) ci.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-line]'); if (!b) return;
      Cart.change(parseInt(b.dataset.line, 10), parseInt(b.dataset.qty, 10));
    });

    // Any add-to-cart form posts through the drawer instead of reloading.
    document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var id = form.querySelector('[name="id"]');
        var qty = form.querySelector('[name="quantity"]');
        if (!id || !id.value) return;
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Reserving…'; }
        var props = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (m && el.value !== '') props[m[1]] = el.value;
        });
        Cart.add(parseInt(id.value, 10), qty ? parseInt(qty.value, 10) : 1, props)
          .catch(function (err) {
            var note = form.querySelector('.pdp-note');
            if (note) note.textContent = err.message;
          })
          .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
      });
    });

    Cart.fetch();
  });
})();
/* Signup confirmation people can actually see. Shopify returns to
 ?customer_posted=true; the theme already swaps the note text, this
  t  urns it into a real confirmation instead of g  rey fine print. */
  (function () {
  function go() {
  if (!/customer_posted=true/.test(location.search)) return;
  var f = document.querySelector('.wait form');
  if (!f) return;
  f.classList.add('is-signed-up');
  var n = f.querySelector('.formnote');
  if (n) n.textContent = 'Your place under the first moon is noted. We will write once, on the night we release.';
  setTimeout(function () { f.scrollIntoView({ block: 'center' }); }, 400);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
  })();